import React from "react";
import styled from "styled-components";

const InfoHero = ({ image }) => (
  <StyledInfoHero>
    <StyledImage image={image} />
  </StyledInfoHero>
);

export default InfoHero;

const StyledInfoHero = styled.div`
  background-color: #000;
  margin: 0 0 20px;
  border-radius: 5px;
  overflow: hidden;
`;

const StyledImage = styled.img`
  position: relative;
  width: 100%;
  height: 300px;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${(props) => props.image});

  @media (max-width: 1023px) {
    background-size: cover;
    width: 100%;
    height: auto;
    min-height: 100px;
  }
`;
